import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditTrailResponse } from './generated/models/audit-trail-response';
import { CaseStateView } from './generated/models/case-state-view';
import { ClaimResponse } from './generated/models/claim-response';
import { DecideHttpRequest } from './generated/models/decide-http-request';
import { DecideResponse } from './generated/models/decide-response';
import { MeRolesResponse } from './generated/models/me-roles-response';
import { QueueResponse } from './generated/models/queue-response';
import { ReleaseHttpRequest } from './generated/models/release-http-request';
import { ReleaseResponse } from './generated/models/release-response';
import { StepForm } from './generated/models/step-form';
import { WorkflowGraph } from './generated/models/workflow-graph';
import { CasesQueueGet$Params } from './generated/fn/cases/cases-queue-get';

export interface WorkflowEngineGateway {
  getMyRoles(caseType?: string): Observable<MeRolesResponse>;
  getQueue(params?: CasesQueueGet$Params): Observable<QueueResponse>;
  getCaseTypeWorkflow(caseType: string): Observable<WorkflowGraph>;
  getCaseState(caseId: string): Observable<CaseStateView>;
  getCaseWorkflow(caseId: string): Observable<WorkflowGraph>;
  getAuditTrail(caseId: string): Observable<AuditTrailResponse>;
  getStepForm(caseId: string, stepId: string): Observable<StepForm>;
  claimStep(caseId: string, stepId: string): Observable<ClaimResponse>;
  decideStep(caseId: string, stepId: string, body: DecideHttpRequest): Observable<DecideResponse>;
  releaseStep(caseId: string, stepId: string, body: ReleaseHttpRequest): Observable<ReleaseResponse>;
}

export const WORKFLOW_ENGINE_GATEWAY = new InjectionToken<WorkflowEngineGateway>(
  'WORKFLOW_ENGINE_GATEWAY',
);